import { OAuth } from '@moovly/clients';
import { createListenerMiddleware } from '@reduxjs/toolkit';
import { groupStatisticsSlice } from '../modules/dashboard';
import accessSlice, { getGroupsOrganization, getUserAccess } from './access.store';
import authSlice, { getCurrentLicense, getCurrentUser } from './auth.store';
import { getLogs } from '../modules/logs/store/logs.store';
import { RootState } from './rootStore';
import SentryService from '../services/Sentry';
import { getMembers } from './members.store';

const globalMiddelWare = createListenerMiddleware();

globalMiddelWare.startListening({
  actionCreator: authSlice.actions.isAuthenticated,
  effect: (action, listenerApi) => {
    if (action.payload) {
      listenerApi.dispatch(getUserAccess());
      listenerApi.dispatch(getCurrentUser());
      listenerApi.dispatch(getCurrentLicense());
    }
  },
});

globalMiddelWare.startListening({
  actionCreator: getUserAccess.fulfilled,
  effect: (action, listenerApi) => {
    if (action.payload) {
      SentryService.setUser(action.payload.user_uuid);
      if (!action.payload.groups.length && !action.payload.organization_id) {
        listenerApi.dispatch(accessSlice.actions.isAllowed(false));
      } else {
        listenerApi.dispatch(
          getGroupsOrganization({ groups: action.payload.groups, organizationId: action.payload.organization_id })
        );
        if (action.payload.workspace_id) {
          listenerApi.dispatch(groupStatisticsSlice.actions.setGroup(action.payload.workspace_id));
        }
      }
    }
  },
});

globalMiddelWare.startListening({
  actionCreator: getGroupsOrganization.fulfilled,
  effect: (action, listenerApi) => {
    if (action.payload) {
      const state = listenerApi.getState() as RootState;
      const userUuid = state.global.user.data?.uuid || state.accesss.userAccess.data?.user_uuid || OAuth.userUuid;
      const isAdminOfSomeGroup = action.payload.groups.some((group) => userUuid && group.admins.includes(userUuid));
      const isAdminOfSomeOrganization = action.payload.info && userUuid && action.payload.info.admins.includes(userUuid);
      if (!isAdminOfSomeGroup && !isAdminOfSomeOrganization) {
        listenerApi.dispatch(accessSlice.actions.isAllowed(false));
      }
      if (isAdminOfSomeOrganization) {
        listenerApi.dispatch(
          getMembers({
            organizationId: action.payload.info.id,
          })
        );
      } else if (isAdminOfSomeGroup) {
        listenerApi.dispatch(
          getMembers({
            groupIds: action.payload.groups.filter((group) => userUuid && group.admins.includes(userUuid)).map((g) => g.id),
          })
        );
      }
    }
  },
});

export default globalMiddelWare;
